import { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';

import App from '@/App.tsx';

import { bootstrapI18n } from './locales/i18nBootstrap';

const main = async () => {
    console.log('main.tsx > main : ', {
        SYSTEM: import.meta.env.VITE_SYSTEM,
        ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
        BUILD_MODE: import.meta.env.VITE_BUILD_MODE,
    });

    /**
     * React render 전에 i18n 초기화와 resource 등록을 완료한다.
     *
     * 이렇게 해야 Cannot update a component while rendering a different component
     * 경고를 피할 수 있다.
     */
    await bootstrapI18n({
        lng: localStorage.getItem('locale') || navigator.language.split(/-|_/)[0] || 'ko',
        fallbackLng: 'ko',
        market: import.meta.env.VITE_MARKET,
    });

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
};

window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    window.location.reload();
});

main();
